import React, { Component } from 'react';
import { BrowserRouter } from 'react-router-dom';
import './App.css';
import NavContainer from './components/navContainer';
import PermissionDeniedView from './components/permissionDeniedView';
import { authProvider } from './utils/authProvider';
import { USER_ROLES } from './utils/Constants';


class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      roles: null
    };
  }

  componentDidMount() {
    this.getRoles();
  }

  async getRoles() {
    const token = await authProvider.getAccessToken();
    const accessToken = JSON.parse(atob(token.accessToken.split('.')[1]));
    this.setState({ roles: accessToken.roles? accessToken.roles : [] });
  }

  handleLogRocket = (accountInfo) => {
    if (!window.ENV.LOGROCKET_APP) {
      return;
    }

    const LogRocket = require('logrocket/setup')({
      sdkServer: 'https://logrocket.americanlogistics.com',
      ingestServer: 'https://logrocket.americanlogistics.com'
    });
    LogRocket.init(window.ENV.LOGROCKET_APP);
    LogRocket.identify(accountInfo.account.accountIdentifier, {
      name: accountInfo.account.name,
      email: accountInfo.account.email,

      // Add your own custom user variables here, ie:
      subscriptionType: 'pro'
    });
  }

  clearCookies = () => {
    var cookies = document.cookie.split(";");

    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var eqPos = cookie.indexOf("=");
      var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
  }

  render() {
    this.clearCookies();
    const accountInfo = authProvider.getAccountInfo();
    localStorage.setItem('user', accountInfo.account.name);
    this.handleLogRocket(accountInfo)

    if(!this.state.roles){
      return (
        <>
        </>
      );
    }else{
      return(
        <BrowserRouter>
          {this.state.roles.includes(USER_ROLES) ?
            <NavContainer />
            : <PermissionDeniedView/>}
        </BrowserRouter>
      )
    }
  }
}

export default App
